import { ReactNode } from 'react';
import styled from 'styled-components';

export type Variant = 'DEFAULT' | 'MEDIUM' | 'LARGE';
export interface InfoListItemProps {
  icon?: string | ReactNode;
  title?: string;
  body?: string;
  variant?: Variant;
  className?: string;
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Icon = styled.div<{ variant: Variant }>`
  margin-right: ${({ theme }) => theme.spacing.M16};
  ${({ variant }) => variant === 'LARGE' && 'width: 40px; height: 40px;'}
  display: flex;
  align-items: center;
`;

const Title = styled.div<{ variant: Variant }>`
  ${({ theme, variant }) =>
    variant === 'DEFAULT'
      ? theme.donedeal.fontSize.B14
      : theme.donedeal.fontSize.B16};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  font-weight: ${({ theme, variant }) =>
    variant === 'LARGE'
      ? theme.donedeal.fontWeight.bold
      : theme.donedeal.fontWeight.regular};
`;

const Text = styled.p<{ variant: Variant }>`
  ${({ theme }) => theme.fontSize.B12};
  color: ${({ theme, variant }) =>
    variant === 'DEFAULT' ? theme.colors.GREY_DARK : theme.colors.GREY_DARK};
  margin-top: ${({ theme }) => theme.spacing.S4};
`;

function InfoListItem({
  icon,
  title,
  body,
  variant = 'DEFAULT',
  className,
}: InfoListItemProps) {
  return (
    <Container className={className}>
      {icon && (
        <Icon variant={variant}>
          {typeof icon === 'string' ? <img src={icon} alt="" /> : icon}
        </Icon>
      )}
      <div>
        <Title variant={variant}>{title}</Title>
        {body && <Text variant={variant}>{body}</Text>}
      </div>
    </Container>
  );
}

export { InfoListItem };
